
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comprehensive-trademark-search",
      function () {
        return require("private-next-pages/comprehensive-trademark-search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comprehensive-trademark-search"])
      });
    }
  